import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';

import colors from 'themes/Main';

const { blue, warning, success, danger, white } = colors;

const toastStyles = () => `
  min-height: 64px;
  height: auto;
  padding: 16px auto;
  padding-left: 16px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 700;
  color: ${white};
  z-index: 9999;
`;

export const Toast = styled(ToastContainer)`
  .Toastify__toast--info {
    ${toastStyles}
    background-color: ${blue};
    box-shadow: 0px 1px 3px rgba(0, 169, 255, 0.2), 0px 2px 2px rgba(0, 169, 255, 0.12), 0px 0px 2px rgba(0, 169, 255, 0.14);
  }

  .Toastify__toast--success {
    ${toastStyles}
    background-color: ${success};
    box-shadow: 0px 1px 3px rgba(0, 199, 141, 0.2), 0px 2px 2px rgba(0, 199, 141, 0.12), 0px 0px 2px rgba(0, 199, 141, 0.14);
  }

  .Toastify__toast--warning {
    ${toastStyles}
    background-color: ${warning};
    box-shadow: 0px 1px 3px rgba(255, 152, 3, 0.2), 0px 2px 2px rgba(255, 152, 3, 0.12), 0px 0px 2px rgba(255, 152, 3, 0.14);
  }

  .Toastify__toast--error {
    ${toastStyles}
    background-color: ${danger};
    box-shadow: 0px 1px 3px rgba(235, 0, 16, 0.2), 0px 2px 2px rgba(235, 0, 16, 0.12), 0px 0px 2px rgba(235, 0, 16, 0.14);
  }
`;
